module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<section class='lottie-container' data-id='<%=id%>'>\n\t<div id=\"<%=id%>\" class=\"canvas-holder\">\n\n\t</div>\n\t<div class=\"scroll-trigger\">\n\t<%blurbs.forEach(function(d,i){%>\n\t\t<div class=\"blurb\" seconds=\"<%=d.seconds%>\"><%-d.text%></div>\t\n\t<%})%>\n\n\t</div>\n\n</section>\t  \n"
  , __filename = "/Users/matthewweber/dev/taiwan/src/js/lottie_template.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<section class='lottie-container' data-id='")
    ; __append(escapeFn(id))
    ; __append("'>\n	<div id=\"")
    ; __line = 2
    ; __append(escapeFn(id))
    ; __append("\" class=\"canvas-holder\">\n\n	</div>\n	<div class=\"scroll-trigger\">\n	")
    ; __line = 6
    ; blurbs.forEach(function(d,i){
    ; __append("\n		<div class=\"blurb\" seconds=\"")
    ; __line = 7
    ; __append(escapeFn(d.seconds))
    ; __append("\">")
    ; __append(d.text)
    ; __append("</div>	\n	")
    ; __line = 8
    ; })
    ; __append("\n\n	</div>\n\n</section>	  \n")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=/Users/matthewweber/dev/taiwan/src/js/lottie_template.ejs

}